import {AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {PriceListService} from '../../../services/price-list.service';
import {PriceListDTO, ProductPriceListLinkDTO, ProviderPriceListLinkDTO} from '../../../models/PriceListDTO';
import {LookupService} from '../../../../common/services/lookup.service';
import {CreateNameValueDTO, NameValueDTO} from '../../../../common/models/NameValueDTO';
import {ActivatedRoute, Router} from '@angular/router';
import {HelpService} from '../../../../other/services/help.service';
import {HelpDTO} from '../../../../other/models/HelpDTO';
import {SettlementDiscountDTO} from '../../../models/SettlementDiscountDTO';
import {UtilService} from '../../../../common/services/util.service';
import {KeycloakService} from 'keycloak-angular';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import {ErrorDialogComponent} from '../../../../common/dialogs/error-dialog/error-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {AddPriceDialogComponent} from '../../dialogs/add-price-dialog/add-price-dialog.component';
import {ConfirmationDialogComponent} from '../../../../common/dialogs/confirmation-dialog/confirmation-dialog.component';
import {Common, createFieldMap, getEndDateValueFromFormControl, setPotentialNullDateValueForFormControl} from '../../../../common/util/Util';
import {DateUtil} from 'src/app/modules/common/util/DateUtil';
import {ProductDTO} from '../../../models/ProductDTO';
import {ProductService} from '../../../services/product.service';
import {PagedRequestDTO} from '../../../../common/models/PagedRequestDTO';
import {Subject, Subscription, throwError} from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import {MatButton} from '@angular/material/button';
import {MatStep} from '@angular/material/stepper';
import {MatSnackBar} from '@angular/material/snack-bar';
import {DisplayStrings} from 'src/app/modules/common/constants/DisplayStrings';
import {FileDTO} from '../../../../common/models/FileDTO';
import {FileService} from '../../../../common/services/file.service';
import {PriceListUploadDTO} from '../../../models/PriceListUploadDTO';
import {GenericListDialogComponent} from '../../../../common/dialogs/generic-list-dialog/generic-list-dialog.component';
import {SharedService} from '../../../../common/services/shared-service';
import {ProviderDTO} from '../../../models/ProviderDTO';
import {ProviderService} from '../../../services/provider.service';
import {EntityTable} from '../../../../common/types/entity-table.enum';
import {LookupValue} from '../../../../clm/types/lookup-value.enum';
import {NameValueCodeDTO} from '../../../../common/models/NameValueCodeDTO';

export function minimumProduct(product: any[]): ValidatorFn {
  return (): { [key: string]: any } | null => {
    return product && product.length > 0 ? null : {minimumProduct: true};
  };
}

export function minimumProviderPriceList(priceList: any[], networkPriceList: any[]): ValidatorFn {
  return (): { [key: string]: any } | null => {
    return (priceList && priceList.length > 0) || (networkPriceList && networkPriceList.length > 0)  ? null : {minimumProviderPriceList: true};
  };
}

const PROVIDER_PRICE_UPLOAD_TEMPLATE_FILE_ID = 1000002;
const PAGE_SIZE = 50;

const PROVIDER_NETWORK = 'Provider Network';
const PROVIDER = 'Provider';

@Component({
  selector: 'app-add-provider-price-list-view',
  templateUrl: './add-provider-price-list-view.component.html',
  styleUrls: ['./add-provider-price-list-view.component.scss', '../../../../../../styles/global/_add-view-edit-styles.scss']
})


export class AddProviderPriceListViewComponent implements OnInit, AfterViewChecked, OnDestroy, AfterViewInit {
  protected readonly PROVIDER = PROVIDER;
  protected readonly PROVIDER_NETWORK = PROVIDER_NETWORK;
  readonly debounceTime = Common.DEBOUNCE_TIME;
  readonly lookupValue = LookupValue;

  heading = 'Price List';
  tabName = 'provider-price-list';
  backPageName = 'enterprise-management';
  userFirstLastName: string;
  discountMessage = DisplayStrings.DISCOUNT_MESSAGE;
  productAlreadySelectedMessage = DisplayStrings.PRODUCT_ALREADY_SELECTED_MESSAGE;
  chosenDataSource = PROVIDER_NETWORK;
  dataSources: string[] = [PROVIDER_NETWORK, PROVIDER];
  dateFormat = DateUtil.dateFormat;
  isEdit: boolean;
  discountRequiredFieldsSelected: boolean;
  productAlreadySelected = false;
  generalFormGroup: FormGroup;
  discountFormGroup: FormGroup;
  priceListFormGroup: FormGroup;
  productFormGroup: FormGroup;
  nameFormControl: FormControl;
  codeFormControl: FormControl;
  administratorFormControl: FormControl;
  typeFormControl: FormControl;
  daysFormControl: FormControl;
  percentageFormControl: FormControl;
  discountStartDateFormControl: FormControl;
  discountEndDateFormControl: FormControl;
  entityFormControl: FormControl;
  productFormControl: FormControl;

  providerPriceList: PriceListDTO;
  administrators: NameValueDTO[];
  types: NameValueDTO[];
  providerNetworks: NameValueCodeDTO[];
  filteredProviders: ProviderDTO[];
  helpInfo: HelpDTO[];
  selectedDiscounts: SettlementDiscountDTO[] = [];
  selectedProviderNetworkPrices: ProviderPriceListLinkDTO[] = [];
  selectedProviderPrices: ProviderPriceListLinkDTO[] = [];
  selectedProducts: ProductPriceListLinkDTO[] = [];
  filteredProducts: ProductDTO[];

  entityTextChanged = new Subject<string>();
  entitySubscription: Subscription;

  productTextChanged = new Subject<string>();
  productSubscription: Subscription;

  priceListDisplayedColumns: string[] = [
    'icons',
    'codingSchema',
    'proprietaryCode',
    'proprietaryDescription',
    'grossAmount',
    'discountAmount',
    'currency',
    'startDate',
    'endDate'
  ];
  priceListDataSource = new MatTableDataSource<ProviderPriceListLinkDTO>();
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  length = 100;
  pageSize = 10;
  pageNumber = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];

  @ViewChild('productBackButton', {static: false}) private productBackButton: MatButton;
  @ViewChild('productClearButton', {static: false}) private productClearButton: MatButton;
  @ViewChild('finishButton', {static: false}) private finishButton: MatButton;
  @ViewChild('generalStep', {static: false}) private generalStep: MatStep;
  @ViewChild('discountStep', {static: false}) private discountStep: MatStep;
  @ViewChild('priceListStep', {static: false}) private priceStep: MatStep;
  @ViewChild('productStep', {static: false}) private productStep: MatStep;

  constructor(
    private formBuilder: FormBuilder,
    private providerPriceListService: PriceListService,
    private lookupService: LookupService,
    private route: ActivatedRoute,
    private helpService: HelpService,
    private changeDetect: ChangeDetectorRef,
    private utilService: UtilService,
    private keycloakService: KeycloakService,
    public dialog: MatDialog,
    private productService: ProductService,
    private router: Router,
    private snackBar: MatSnackBar,
    private fileService: FileService,
    private sharedService: SharedService,
    private providerService: ProviderService
  ) {
    this.nameFormControl = new FormControl('', [Validators.required]);
    this.codeFormControl = new FormControl('', [Validators.required]);
    this.administratorFormControl = new FormControl('', [Validators.required]);
    this.typeFormControl = new FormControl('', [Validators.required]);
    this.daysFormControl = new FormControl('');
    this.percentageFormControl = new FormControl('');
    this.discountStartDateFormControl = new FormControl('');
    this.discountEndDateFormControl = new FormControl('');
    this.entityFormControl = new FormControl('');
    this.productFormControl = new FormControl('');

    this.generalFormGroup = this.formBuilder.group({
      name: this.nameFormControl,
      code: this.codeFormControl,
      administrator: this.administratorFormControl,
      type: this.typeFormControl
    });

    this.discountFormGroup = this.formBuilder.group({
      days: this.daysFormControl,
      percentage: this.percentageFormControl,
      settlementStartDate: this.discountStartDateFormControl,
      settlementEndDate: this.discountEndDateFormControl
    });

    this.priceListFormGroup = this.formBuilder.group({
      entity: this.entityFormControl
    }, {validators: [minimumProviderPriceList(this.selectedProviderPrices, this.selectedProviderNetworkPrices)]});

    this.productFormGroup = this.formBuilder.group({
      product: this.productFormControl
    });

    this.entitySubscription = this.entityTextChanged.pipe(
      debounceTime(this.debounceTime)
    ).subscribe(() => {
      if (this.chosenDataSource === PROVIDER) {
        this.getFilteredListOfProviders();
      }
    });

    this.productSubscription = this.productTextChanged.pipe(
      debounceTime(this.debounceTime)
    ).subscribe(() => {
      this.getFilteredListOfProducts();
    });
  }

  ngOnInit(): void {
    if (this.route.snapshot.url[1].path === 'edit-provider-price-list') {
      this.isEdit = true;
      this.route.paramMap.subscribe((params) => {
        this.getProviderPriceListById(Number(params.get('id')));
      });
    }
    this.keycloakService.loadUserProfile().then((profile) => {
      this.userFirstLastName = `${profile.firstName} ${profile.lastName}`;
    });
    this.getListOfLookupValues(this.lookupValue.PriceListType);
    this.getListOfLookupValues(this.lookupValue.Administrator);
    this.getListOfLookupValues(this.lookupValue.ProviderNetwork);
    this.getHelpInfo('Provider Price List');
  }

  ngAfterViewChecked(): void {
    this.changeDetect.detectChanges();
  }

  ngOnDestroy(): void {
  }

  ngAfterViewInit() {
    if (!this.isEdit) {
      this.priceListDataSource.sort = this.sort;
      this.priceListDataSource.paginator = this.paginator;
    }
  }

  getProviderPriceListById(id: number): void {
    this.providerPriceListService.getPriceList(id).subscribe(
      (response) => {
        this.providerPriceList = response;
        this.setFormsForEdit(response);
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.handleError(error.businessMessage);
      }
    );
  }

  setFormsForEdit(data: PriceListDTO) {
    this.discountRequiredFieldsSelected = false;

    if (data.settlementDiscounts) {
      this.selectedDiscounts = data.settlementDiscounts;
    }

    if (data.providerNetworkPriceLists) {
      this.selectedProviderNetworkPrices = data.providerNetworkPriceLists;
    }

    if (data.providerPriceLists) {
      this.selectedProviderPrices = data.providerPriceLists;
    }

    this.nameFormControl.setValue(data.name);
    this.codeFormControl.setValue(data.code);
    this.administratorFormControl.setValue(data.administrator.name);
    this.typeFormControl.setValue(data.providerPriceListType.name);

    if (data.productPriceLists) {
      this.selectedProducts = data.productPriceLists;
    }
    this.resetPriceListFormGroup();
    this.toggleDataSource(this.chosenDataSource);
  }

  getListOfLookupValues(entity: string): void {
    this.lookupService.getListOfLookupValues(entity).subscribe(
      (response: NameValueCodeDTO[]) => {
        if (entity === this.lookupValue.Administrator) {
          this.administrators = response;
        } else if (entity === this.lookupValue.PriceListType) {
          this.types = response;
        } else if (entity === this.lookupValue.ProviderNetwork) {
          this.providerNetworks = response;
        }
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.handleError(error.businessMessage);
      }
    );
  }

  onInputChangedSearchProducts($event) {
    this.productTextChanged.next($event.target.value);
  }

  onInputChangedSearchProviders($event) {
    this.entityTextChanged.next($event.target.value);
  }

  getHelpInfo(componentName: string) {
    this.helpService.getListOfHelpInfo(componentName).subscribe(
      (response) => {
        this.helpInfo = response;
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.handleError(error.businessMessage);
      }
    );
  }

  getInfoTooltip(inputName: string): string {
    let message = '';
    if (this.helpInfo) {
      const helpInfo = this.helpInfo.find((help) => help.inputName === inputName);
      message = helpInfo ? helpInfo.inputInfo : '';
    }
    return message;
  }

  resetGeneralFormGroup() {
    this.generalFormGroup.reset();
  }

  resetDiscountFormGroup() {
    this.discountFormGroup.reset();
  }

  resetPriceFormGroup() {
    this.selectedProviderPrices = [];
    this.selectedProviderNetworkPrices = [];
    this.chosenDataSource = PROVIDER;
    this.resetPriceListFormGroup();
    this.toggleDataSource(this.chosenDataSource);
  }

  resetProductFormGroup() {
    this.productFormControl.reset();
    this.selectedProducts = [];
  }

  removeDiscount(discount: SettlementDiscountDTO) {
    const index = this.selectedDiscounts.indexOf(discount, 0);
    if (index > -1) {
      this.selectedDiscounts.splice(index, 1);
    }
  }

  editDiscount(discount: SettlementDiscountDTO) {
    this.removeDiscount(discount);
    this.daysFormControl.setValue(discount.days);
    this.percentageFormControl.setValue(discount.percentage);
    this.discountStartDateFormControl.setValue(new Date(discount.startDate));
    this.discountEndDateFormControl.setValue(setPotentialNullDateValueForFormControl(discount.endDate));
  }

  getDiscountDisplayString(discount: SettlementDiscountDTO) {
    return `${this.utilService.dateFormat(discount.startDate)} - ${discount.endDate != null ? this.utilService.dateFormat(discount.endDate) : ''}: ${discount.days} days | ${discount.percentage} percent`;
  }

  getHeadingDisplayString() {
    let heading = this.heading;
    if (this.isEdit) {
      heading = `Edit ${heading} - ${this.nameFormControl.value}`;
    } else if (this.nameFormControl.value !== '') {
      heading = `Add ${heading} - ${this.nameFormControl.value}`;
    } else {
      heading = `Add Price List`;
    }

    return heading;
  }

  addDiscount() {
    if (this.validateDiscountForm()) {
      this.discountRequiredFieldsSelected = true;

      let discount: SettlementDiscountDTO;
      discount = {
        providerPriceList: {
          name: this.nameFormControl.value,
          value: this.providerPriceList?.providerPriceListId
        },
        startDate: new Date(this.discountStartDateFormControl.value),
        endDate: getEndDateValueFromFormControl(this.discountEndDateFormControl),
        days: this.daysFormControl.value,
        percentage: this.percentageFormControl.value,
        created: new Date(),
        createdBy: this.userFirstLastName,
        settlementDiscountId: null,
        tenantId: null,
        updated: null,
        updatedBy: null
      };
      this.selectedDiscounts.push(discount);
      this.resetDiscountFormGroup();
    }
  }

  validateDiscountForm(): boolean {
    return this.daysFormControl.value !== '' && this.percentageFormControl.value !== '' && this.discountStartDateFormControl.value !== '';
  }

  toggleDataSource(value: string) {
    if (value === PROVIDER) {
      this.entityFormControl.setValue((this.selectedProviderPrices && this.selectedProviderPrices.length > 0) ? this.selectedProviderPrices[0].provider.name : '');
      this.getFilteredListOfProviders();
    } else {
      this.entityFormControl.setValue((this.selectedProviderNetworkPrices && this.selectedProviderNetworkPrices.length > 0) ? this.selectedProviderNetworkPrices[0].providerNetwork.name : '');
    }
    this.setDataSource(value, this.entityFormControl.value);
  }

  setDataSource(entityType: string, entityName: string) {
    if (entityType === PROVIDER) {
      const priceList = this.selectedProviderPrices;
      this.priceListDataSource = new MatTableDataSource<ProviderPriceListLinkDTO>(this.filterProviderDataSource(priceList, entityName));
      this.priceListDataSource.sort = this.sort;
      this.priceListDataSource.paginator = this.paginator;
    } else {
      const priceList = this.selectedProviderNetworkPrices;
      this.priceListDataSource = new MatTableDataSource<ProviderPriceListLinkDTO>(this.filterGroupDataSource(priceList, entityName));
      this.priceListDataSource.sort = this.sort;
      this.priceListDataSource.paginator = this.paginator;
    }
  }

  getFilteredProviderValues(): any[] {
    return this.chosenDataSource === PROVIDER ? this.filteredProviders : this.providerNetworks;
  }

  handleError(errorMessage: string) {
    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      width: '40vw',
      data: errorMessage
    });
  }

  filterProviderDataSource(priceLists: ProviderPriceListLinkDTO[], entityName: string): ProviderPriceListLinkDTO[] {
    return priceLists.filter(priceList => priceList.provider.name === entityName);
  }

  filterGroupDataSource(priceLists: ProviderPriceListLinkDTO[], entityName: string): ProviderPriceListLinkDTO[] {
    return priceLists.filter(priceList => priceList.providerNetwork.name === entityName);
  }

  openPriceDialog(price: ProviderPriceListLinkDTO) {
    let index = -1;
    if (price == null) {
      price = new ProviderPriceListLinkDTO();
      if (this.chosenDataSource === PROVIDER) {
        const provider = this.getSelectedProvider();
        if (provider) {
          price.provider = CreateNameValueDTO(provider.providerId, provider.name);
        }
        else {
          this.openSnackBar('Please search for and select a provider before trying to add a price', 'Dismiss');
          return;
        }
      } else {
        const providerNetwork = this.getSelectedProviderNetwork();
        if (providerNetwork) {
          price.providerNetwork = providerNetwork;
        }
        else {
          this.openSnackBar('Please search for and select a provider network before trying to add a price', 'Dismiss');
          return;
        }
      }
    } else {
      if (this.chosenDataSource === PROVIDER) {
        index = this.selectedProviderPrices.findIndex((x) => (x.provider.value === price.provider.value && x.codingSchema.codingSchemaId === price.codingSchema.codingSchemaId));
      } else {
        index = this.selectedProviderNetworkPrices.findIndex((x) => (x.providerNetwork.value === price.providerNetwork.value && x.codingSchema.codingSchemaId === price.codingSchema.codingSchemaId));
      }
    }
    const dialogRef = this.dialog.open(AddPriceDialogComponent, {
      width: '50vw',
      height: '80vh',
      data: {price, index}
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (this.chosenDataSource === PROVIDER) {
          if (index !== -1) {
            this.selectedProviderPrices.splice(result.index, 1);
          }
          this.selectedProviderPrices.push(result.price);
          this.toggleDataSource(this.chosenDataSource);
        } else {
          if (index !== -1) {
            this.selectedProviderNetworkPrices.splice(result.index, 1);
          }
          this.selectedProviderNetworkPrices.push(result.price);
          this.toggleDataSource(this.chosenDataSource);
        }
        this.resetPriceListFormGroup();
      }
    });
  }

  removePrice(row) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '40vw',
      data: 'Are you sure you wish to delete this entity?'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (this.chosenDataSource === PROVIDER) {
          this.selectedProviderPrices.splice(this.selectedProviderPrices.findIndex(deletePrice => deletePrice === row), 1);
          this.toggleDataSource(this.chosenDataSource);
        } else {
          this.selectedProviderNetworkPrices.splice(this.selectedProviderNetworkPrices.findIndex(deletePrice => deletePrice === row), 1);
          this.toggleDataSource(this.chosenDataSource);
        }
        this.resetPriceListFormGroup();
      }
    });
  }

  formatToCurrency(amount) {
    amount = Number(amount);
    return amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  }

  getSelectedProvider(): ProviderDTO {
    return this.filteredProviders ? this.filteredProviders.find(
      item => item.name === this.entityFormControl.value
    ) : null;
  }

  getSelectedProviderNetwork(): NameValueCodeDTO {
    return this.providerNetworks ? this.providerNetworks.find(
      item => item.name === this.entityFormControl.value
    ) : null;
  }

  addProduct() {
    const product = this.filteredProducts.find(x => this.productFormControl.value.includes(x.productCode));
    if (product != null) {
      const productName = this.productFormControl.value.split(' - ')[1].trim();
      const existingProduct = this.selectedProducts.find(x => productName === x.product.name.trim());
      if (!existingProduct) {
        this.productAlreadySelected = false;
        this.selectedProducts.push({created: null, createdBy: null, tenantId: null, updated: null, updatedBy: null, product});
      } else {
        this.productAlreadySelected = true;
      }
    }
    this.productFormControl.reset();
  }

  getProductDisplayString(product: ProductDTO) {
    return `${this.utilService.dateFormat(product.startDate)} - ${product.endDate != null ? this.utilService.dateFormat(product.endDate) : ''}: ${product.productCode} - ${product.name}`;
  }

  getProductSelectListDisplayString(product: ProductDTO) {
    return `${product.productCode} - ${product.name}`;
  }

  removeProduct(product: ProductPriceListLinkDTO) {
    const index = this.selectedProducts.findIndex(x => x.product.productCode === product.product.productCode);
    if (index > -1) {
      this.selectedProducts.splice(index, 1);
    }
    this.productFormGroup.reset();
  }

  checkProductValue() {
    if (this.productFormControl.value && this.productFormControl.value.length > 0) {
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        width: '40vw',
        data: `Product ${this.productFormControl.value} has not been added to the price list. Click YES to add it, or NO to continue without it.`
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          const product = this.filteredProducts.find(x => this.productFormControl.value.includes(x.productCode));
          if (product != null) {
            this.selectedProducts.push({created: null, createdBy: null, tenantId: null, updated: null, updatedBy: null, product});
          }
          this.productFormControl.reset();
          this.submitPriceList();

        } else {
          this.submitPriceList();
        }
      });
    } else {
      this.submitPriceList();
    }
  }

  submitPriceList() {
    this.disableControls();
    const priceListDTO = this.getPriceListPayload();
    this.providerPriceListService.savePriceList(priceListDTO).subscribe(
      response => {
        if (this.isEdit) {
          this.openSnackBar(
            `${response.name} edited successfully`,
            'Dismiss'
          );
        } else {
          this.openSnackBar(
            `${response.name} saved successfully`,
            'Dismiss'
          );
        }
        this.router.navigate(['/enterprise-management'], {queryParams: {tab: 'provider-price-list'}});
      },
      error => {
        throwError(error);
        this.enableControls();
        this.handleError(error.message);
      },
      () => {
        this.enableControls();
      }
    );
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 10000
    });
  }

  downloadFile() {
    this.fileService.getFile(PROVIDER_PRICE_UPLOAD_TEMPLATE_FILE_ID).subscribe(
      (file: FileDTO) => {
        if (this.selectedProviderPrices.length > 0 || this.selectedProviderNetworkPrices.length > 0) {
          this.downloadFileFromConvertedPriceListLinkDTOs(file.name + file.extension, this.selectedProviderPrices.concat(this.selectedProviderNetworkPrices));
        } else {
          this.fileService.promptBrowserFileDownloadFromFileDTO(file);
        }
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.handleError(error.businessMessage);
      }
    );
  }

  fileUploadListener(e) {
    const files: FileList = e.target.files;

    // If files were uploaded
    if (files && files.length > 0) {
      // Read the first (and only) file
      const file: File = files.item(0);
      const reader: FileReader = new FileReader();
      reader.readAsText(file);
      reader.onload = () => {
        const txt = reader.result as string;
        let lines = txt.split('\r\n');
        const delimiter = lines[0].includes(',') ? ',' : ';';
        lines = lines.filter(line => (line.trim() !== '' && line.trim() !== '""' && line.trim() !== '\"\"'));

        // Exit if not valid
        const isFileValid = this.isFileValid(lines, delimiter);
        if (!isFileValid) {
          e.target.value = '';
          return;
        }

        // Populate the priceListUploadArray
        const priceListUploadArray: PriceListUploadDTO[] = [];
        let firstLine = true;
        lines.forEach(element => {
          const cols: string[] = element.split(delimiter);
          cols.forEach(col => {
            if (col === '') {
              col = null;
            }
          });
          if (firstLine) {
            firstLine = false;
          } else {
            priceListUploadArray.push(this.populatePriceListUploadDTO(cols));
          }
        });

        // Update the selected prices
        this.updateSelectedPrices(priceListUploadArray);
        this.resetPriceListFormGroup();

        e.target.value = '';
        this.sharedService.openSnackBar('Providers imported successfully', 'Dismiss');
      };
    }
  }

  disableFinishButton(): boolean {
    let isDisabled = false;
    if (this.selectedProviderPrices.length === 0 && this.selectedProviderNetworkPrices.length === 0) {
      isDisabled = true;
    }
    else if (this.createdBySystem()) {
      isDisabled = true;
    }
    return isDisabled;
  }

  getFinishButtonTooltip(): string | null {
    let tooltip = DisplayStrings.generic.disabledButton;
    if (this.selectedProviderPrices.length === 0 && this.selectedProviderNetworkPrices.length === 0) {
      tooltip = 'Assign at least 1 price to a provider or a provider network.';
    }
    else if (this.createdBySystem()) {
      tooltip = DisplayStrings.generic.externalSystem;
    }
    return tooltip;
  }

  private getFilteredListOfProducts(): void {
    const pagedRequestDTO = new PagedRequestDTO();
    pagedRequestDTO.entityClass = EntityTable.TblProduct;
    pagedRequestDTO.pageNumber = 0;
    pagedRequestDTO.pageSize = PAGE_SIZE;

    pagedRequestDTO.fieldMap = createFieldMap(
      'name',
      this.productFormControl.value
    );

    this.productService.getListOfProducts(pagedRequestDTO).subscribe(
      (response) => {
        this.filteredProducts = response.resultList;
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.handleError(error.businessMessage);
      },
    );
  }

  private getFilteredListOfProviders(): void {
    const pagedRequestDTO = new PagedRequestDTO();
    pagedRequestDTO.entityClass = EntityTable.TblProvider;
    pagedRequestDTO.pageNumber = 0;
    pagedRequestDTO.pageSize = PAGE_SIZE;

    pagedRequestDTO.fieldMap = createFieldMap(
      'name',
      this.entityFormControl.value
    );

    this.providerService.getListOfProviders(pagedRequestDTO).subscribe(
      (response) => {
        this.filteredProviders = response.resultList;
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.handleError(error.businessMessage);
      },
    );
  }

  private updateSelectedPrices(priceListUploadArray: PriceListUploadDTO[]) {
    this.selectedProviderPrices = [];
    this.selectedProviderNetworkPrices = [];
    // Convert the upload DTO
    this.providerPriceListService.convertPriceListUploadDTO(priceListUploadArray).subscribe(
      (response: ProviderPriceListLinkDTO[]) => {
        const errorList: string[] = [];
        errorList.push('groupLicenceNumber;providerLicenceNumber;codingSchemaCode;currency');
        response.forEach(price => {
          // Write errors to an error list
          if (
            (price.provider != null && price.provider.value == null) ||
            (price.providerNetwork != null && price.providerNetwork.value == null) ||
            price.codingSchema.codingSchemaId == null ||
            price.currency.value == null
          ) {
            errorList.push(`${price.providerNetwork?.name};${price.provider?.name};${price.codingSchema?.code};${price.currency?.name}`);
          }
          // Otherwise update the selected provider prices
          else if (price.provider != null) {
            this.selectedProviderPrices.push(price);
          }
          // Or update the selected provider network prices
          else if (price.providerNetwork != null) {
            this.selectedProviderNetworkPrices.push(price);
          }
        });
        // Refresh the data source
        if (this.selectedProviderPrices.length == 0 && this.selectedProviderNetworkPrices.length > 0) {
          this.chosenDataSource = PROVIDER_NETWORK;
          this.toggleDataSource(this.chosenDataSource);
        }
        else {
          this.chosenDataSource = PROVIDER;
          this.toggleDataSource(this.chosenDataSource);
        }
        this.resetPriceListFormGroup();
        // Open the dialog to show errors if any
        if (errorList.length > 1) {
          this.dialog.open(GenericListDialogComponent, {
            width: '80vw',
            data: {list: errorList, heading: 'Rows with Fields not Found in Database'}
          });
        }
        // Alert user of (partial?) success
        this.openSnackBar(`Prices imported ${errorList.length > 1 ? 'with errors' : 'successfully'}`, 'Dismiss');
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.handleError(error.businessMessage);
      }
    );
  }

  private populatePriceListUploadDTO(cols: string[]): PriceListUploadDTO {
    const priceListUploadDTO = new PriceListUploadDTO();
    priceListUploadDTO.providerNetworkCode = cols[0];
    priceListUploadDTO.providerPracticeNumber = cols[1];
    priceListUploadDTO.codingSchemaCode = cols[2];
    priceListUploadDTO.proprietaryCode = cols[3];
    priceListUploadDTO.proprietaryDescription = cols[4];
    priceListUploadDTO.currency = cols[5];
    priceListUploadDTO.grossAmount = cols[6];
    priceListUploadDTO.discountAmount = cols[7];
    priceListUploadDTO.startDate = cols[8];
    priceListUploadDTO.endDate = cols[9];
    if (priceListUploadDTO.providerNetworkCode != null || priceListUploadDTO.providerPracticeNumber != null) {
      return priceListUploadDTO;
    }
  }

  private isFileValid(lines: string[], delimiter: string) {
    let isFileValid = true;
    if (!this.allColumnsExist(lines, delimiter)) {
      this.handleError('The uploaded file does not have the expected columns.');
      isFileValid = false;
    } else if (lines[1].trim().toUpperCase().includes('E.G.')) {
      this.handleError('The example row (e.g.) still exists in row 1 of the uploaded file.');
      isFileValid = false;
    }

    let firstLine = true;
    const numberOfColumns = lines[0].split(delimiter).length;
    const errorList: string[] = [];
    errorList.push('businessLicenceNumber;codingSchemaCode;currency;grossAmount;startDate');
    for (const line of lines) {
      if (firstLine) {
        firstLine = false;
        continue;
      }
      if (line.split(delimiter)[6] != null && line.split(delimiter)[6].includes(',') || line.split(delimiter)[7] != null && line.split(delimiter)[7].includes(',')) {
        this.handleError('There are gross amount and discount values that have commas instead of points as the decimal place.');
        isFileValid = false;
        break;
      } else if (line.trim() !== '' && line.split(delimiter).length != numberOfColumns) {
        this.handleError('There are rows where the number of columns do not match the number of columns in the header - ensure points are being used for decimals instead of commas..');
        isFileValid = false;
        break;
      } else if (!this.allRequiredFieldsHaveData(line, delimiter)) {
        errorList.push(`${line.split(delimiter)[0] != null && line.split(delimiter)[0] !== '' ? line.split(delimiter)[0] : line.split(delimiter)[1]};${line.split(delimiter)[2]};${line.split(delimiter)[5]};${line.split(delimiter)[6]};${line.split(delimiter)[8]}`);
        this.dialog.open(GenericListDialogComponent, {
          width: '80vw',
          data: {list: errorList, heading: 'Rows with Missing Required Fields'}
        });
        isFileValid = false;
        break;
      } else if ((line.split(delimiter)[0] != null && line.split(delimiter)[0] !== '') && (line.split(delimiter)[1] != null && line.split(delimiter)[1] !== '')) {
        this.handleError('There are prices that are applied to both provider and provider network - ensure that EITHER the providerPracticeNumber column OR the providerNetworkCode column is completed.');
        isFileValid = false;
        break;
      }
    }
    return isFileValid;
  }

  private allColumnsExist(lines: string[], delimiter: string): boolean {
    return lines[0].split(delimiter)[0]?.trim() === 'providerNetworkCode' &&
      lines[0].split(delimiter)[1]?.trim() === 'providerPracticeNumber' &&
      lines[0].split(delimiter)[2]?.trim() === 'codingSchemaCode' &&
      lines[0].split(delimiter)[3]?.trim() === 'proprietaryCode' &&
      lines[0].split(delimiter)[4]?.trim() === 'proprietaryDescription' &&
      lines[0].split(delimiter)[5]?.trim() === 'currency' &&
      lines[0].split(delimiter)[6]?.trim() === 'grossAmount' &&
      lines[0].split(delimiter)[7]?.trim() === 'discountAmount' &&
      lines[0].split(delimiter)[8]?.trim() === 'startDate' &&
      lines[0].split(delimiter)[9]?.trim() === 'endDate';
  }

  private allRequiredFieldsHaveData(line: string, delimiter: string): boolean {
    return ((line.split(delimiter)[0] != null && line.split(delimiter)[0] !== '') || (line.split(delimiter)[1] != null && line.split(delimiter)[1] !== '')) && // providerNetworkCode or providerPracticeNumber
      (line.split(delimiter)[2] != null && line.split(delimiter)[2] !== '') && // codingSchemaCode
      (line.split(delimiter)[5] != null && line.split(delimiter)[5] !== '') && // currency
      (line.split(delimiter)[6] != null && line.split(delimiter)[6] !== '') && // grossAmount
      (line.split(delimiter)[8] != null && line.split(delimiter)[8] !== ''); // startDate
  }

  private downloadFileFromConvertedPriceListLinkDTOs(fileName: string, selectedPrices: ProviderPriceListLinkDTO[]) {
    this.providerPriceListService.convertPriceListLinkDTO(selectedPrices).subscribe(
      (uploadDTOs: PriceListUploadDTO[]) => {
        this.fileService.promptBrowserFileDownloadFromDataObject(uploadDTOs, fileName);
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.handleError(error.businessMessage);
      }
    );
  }

  private disableControls() {
    this.productFormGroup.disable();
    this.productBackButton.disabled = true;
    this.productClearButton.disabled = true;
    this.finishButton.disabled = true;
    this.generalStep.editable = false;
    this.discountStep.editable = false;
    this.priceStep.editable = false;
    this.productStep.editable = false;
  }

  private enableControls() {
    this.productFormGroup.enable();
    this.productBackButton.disabled = false;
    this.productClearButton.disabled = false;
    this.finishButton.disabled = false;
    this.generalStep.editable = true;
    this.discountStep.editable = true;
    this.priceStep.editable = true;
    this.productStep.editable = true;
  }

  private getPriceListPayload(): PriceListDTO {
    const created = this.isEdit ? this.providerPriceList.created : new Date();
    const createdBy = this.isEdit ? this.providerPriceList.createdBy : this.userFirstLastName;
    const updated = this.isEdit ? new Date() : null;
    const updatedBy = this.isEdit ? this.userFirstLastName : null;

    const priceListDTO = new PriceListDTO();
    priceListDTO.providerPriceListId = this.isEdit ? this.providerPriceList.providerPriceListId : null;
    priceListDTO.name = this.nameFormControl.value;
    priceListDTO.code = this.codeFormControl.value;
    priceListDTO.providerPriceListType = this.types.find(x => x.name === this.typeFormControl.value);
    priceListDTO.administrator = this.administrators.find(x => x.name === this.administratorFormControl.value);
    priceListDTO.created = created;
    priceListDTO.createdBy = createdBy;
    priceListDTO.updated = updated;
    priceListDTO.updatedBy = updatedBy;

    this.selectedDiscounts.forEach(x => {
      x.created = created;
      x.createdBy = createdBy;
      x.updated = updated;
      x.updatedBy = updatedBy;
    });
    priceListDTO.settlementDiscounts = this.selectedDiscounts;

    // Provider Price Lists
    this.selectedProviderPrices.forEach(x => {
      x.created = created;
      x.created = created;
      x.createdBy = createdBy;
      x.updated = updated;
      x.updatedBy = updatedBy;
    });
    priceListDTO.providerPriceLists = this.selectedProviderPrices;

    // Provider Network Price Lists
    this.selectedProviderNetworkPrices.forEach(x => {
      x.created = created;
      x.createdBy = createdBy;
      x.updated = updated;
      x.updatedBy = updatedBy;
    });
    priceListDTO.providerNetworkPriceLists = this.selectedProviderNetworkPrices;

    // Product Price Lists
    this.selectedProducts.forEach(x => {
      x.created = created;
      x.createdBy = createdBy;
      x.updated = updated;
      x.updatedBy = updatedBy;
    });
    priceListDTO.productPriceLists = this.selectedProducts;

    return priceListDTO;
  }

  private resetPriceListFormGroup() {
    this.priceListFormGroup = this.formBuilder.group({
      entity: this.entityFormControl
    }, {validators: [minimumProviderPriceList(this.selectedProviderPrices, this.selectedProviderNetworkPrices)]});
  }

  private createdBySystem(): boolean {
    return this.providerPriceList && this.providerPriceList.createdBy.toLowerCase() === 'system';
  }
}
